function collectionSpinner() {
  if (window.themeVariables.settings.pageType !== 'collection') return;

  const container = document.querySelector('.shopify-section--main-collection');
  if (!container) return;

  document.addEventListener("theme:loading:start", function() {
    container.classList.add('collection-loading')
  });
  document.addEventListener("theme:loading:end", function(){
    container.classList.remove('collection-loading')
  });
}

window.addEventListener('load', function() {
  collectionSpinner()
})
